<style lang="less">
.Support_bank{
	.title{
		width: 100%;
		height: 25px;
		padding: 27px 0 7px;
		color: #2e4175;
		font-family: Flyme;
		font-size: 14px;
		font-weight: 500;
		text-align: center;
		padding-bottom: 7px;
	}
	.table{
		margin: 0 24px;
		.head{
			background: #f2f2f2;
			&.item{
				.label, .info{
					font-size: 12px;
					font-weight: 500;
				}
			}
		}
		.item{
			overflow: hidden;
			display: -webkit-box; display:flex;
			-webkit-box-align: center; align-items: center;
			-webkit-box-pack: center; justify-content: center;
			.label, .info{
				-webkit-box-flex: 1; -moz-box-flex: 1; -ms-flex: 1; flex: 1;
				display: -webkit-box; display:flex;
				-webkit-box-align: center; align-items: center;
				-webkit-box-pack: center; justify-content: center;
				height: 47px;
				border-bottom: 1px dotted #f2f2f2;
			}
			.label{
				font-size: 12px;
				font-weight: 500;
			}
			.line{
				width: 1px;
				height: 48px;
				background: #c3c3c3;
				transform: scaleX(0.5);
			}
			.info{
				img{
					height: 12px;
				}
			}
		}
	}
	.hor{
		width: 100%;
		height: 1px;
		display: block;
		background: #c3c3c3;
		transform: scaleY(0.5);
	}
	.more{
		text-align: center;
		padding: 13px 0 30px 0;
		color: #999;
		font-size: 12px;
		font-weight: 400;
	}
}
</style>

<template>
	<!-- Main Support_bank -->
	<section class="Support_bank">
		<h3 class="title">- 本业务只支持储蓄卡 -</h3>
		<div class="table" v-if="list.length > 0">
			<div class="hor"></div>
			<div class="item head">
				<div class="line"></div>
				<div class="label">银行</div>
				<div class="line"></div>
				<div class="info">是否支持</div>
				<div class="line"></div>
			</div>
			<template v-for="(item, index) in list" >
				<div class="item" v-bind:key="'item_' + index">
					<div class="line"></div>
					<div class="label">{{item.name}}</div>
					<div class="line"></div>
					<div class="info">
						<img src="../assets/icon_support.png">
						<!-- <img src="../assets/icon_dissupport.png" v-else> -->
					</div>
					<div class="line"></div>
				</div>
			</template>
			<div class="hor"></div>
		</div>
		<div class="more">更多银行，敬请期待</div>
	</section>
</template>

<script>
	import android from '@flyme/jr/js/android.js';

	import axios from '../axios.js';
	import apis from '../apis.js';
	import config from '../config.js';

	export default {
		data: function () {
			return {
				userinfo: {},
				list: []
			};
		},
		components: {
		},
		created: function () {
			this.getUserInfo();
		},
		mounted: function () {
		},
		methods: {
			getUserInfo: function () {
				let _this = this;
				android('getUserInfo', {}, (d) => {
					_this.userinfo = d;
					this.getList();
				});
			},
			getList: function () {
				let _this = this;
				axios.post(apis.support_list, {
					user_id: this.userinfo.userId,
					partner_id: config.partner_id,
					partner_cp_type: config.partner_cp_type
				}).then(function(d) {
					console.log('server_config', d);
					_this.list = d.value.rows;
				});
			},
		}
	};
</script>


// WEBPACK FOOTER //
// src/pages/Support_bank.vue